import { render, staticRenderFns } from "./StockItemMovementTable.vue?vue&type=template&id=55447714"
import script from "./StockItemMovementTable.vue?vue&type=script&lang=ts"
export * from "./StockItemMovementTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports